import React from 'react'

export default function HomeCard(props) {
    return (
        <div style={{boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px'}} className='w-[18.7rem] h-[5.7rem] rounded-[14px] shadow-2xl'>
           <div className='flex items-center justify-center h-full'>
            <div className='w-[85%]'>
                <div className='flex items-center gap-3'>
                    <img className='w-[3.54rem]' src={props.img} />
                    <p className='text-[0.95rem] font-[600] text-[#1F2A37]'>{props.text}</p>
                </div>
            </div>
            </div>
        </div>
    );
}